import React from "react";
import Button from "pages/_components/Button";
import { useHistory } from "react-router-dom";
import { bool, func, string } from "prop-types";
import { getDisplay } from "util/device";

const ArrowBack = ({ backLinkTo, onClickBack, showLabel }) => {
    ArrowBack.propTypes = {
        backLinkTo: string,
        onClickBack: func,
        showLabel: bool,
    };

    ArrowBack.defaultProps = {
        backLinkTo: "",
        onClickBack: null,
        showLabel: false,
    };

    const history = useHistory();

    const handleBack = () => {
        if (onClickBack) {
            onClickBack();
            return;
        }
        if (backLinkTo) {
            history.push(backLinkTo);
            return;
        }
        history.goBack();
    };

    const backText = showLabel ? "" : "view-back";

    return (
        <Button
            className={`btn toolbar-btn ${backText}`}
            onClick={handleBack}
            image={
                getDisplay() === "mobile"
                    ? `images/figma/icon/arrow-back-mobile.svg`
                    : `images/figma/icon/arrow-back.svg`
            }
            block={false}
            label="global.back"
            bsStyle="link"
        />
    );
};

export default ArrowBack;
